import { z } from 'zod';
/**
 * SQL Server `uniqueidentifier` values. NEWSEQUENTIALID() and NEWID() produce GUIDs whose
 * textual form does not honor RFC 4122 version/variant nibbles (e.g. `…-F111-…`), so Zod's
 * strict `.uuid()` rejects real ids from the database. Validate shape only. docs/BUILD.md §5.
 */
export const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const Guid = z.string().regex(GUID_PATTERN, 'Expected a GUID');
export const isGuid = (value) => typeof value === 'string' && GUID_PATTERN.test(value);
//# sourceMappingURL=ids.js.map